import { IApiResponse } from "common//models";
import { API_CONFIG, LOCAL_URL, PRODUCTION, UAT } from "common/config";
import { COMMON_JS } from "common/scripts";

interface IApiIndents {
  sendPushNotify: (args: any) => Promise<IApiResponse>;
  getReportedVehicles: (args: any) => Promise<IApiResponse>;
  manageReportedVehicles: (args: any) => Promise<IApiResponse>;
  removeReportedVehicle: (args: any) => Promise<IApiResponse>;
  getVehicleInfo: (args: any) => Promise<IApiResponse>;
  getIndentsDropdown: (args: any) => Promise<IApiResponse>;
  manageIndent: (args: any) => Promise<IApiResponse>;
  linkIndent: (args: any) => Promise<IApiResponse>;
  getTrips: (args: any) => Promise<IApiResponse>;
  getTripsList: (args: any) => Promise<IApiResponse>;
  getLinkedTrips: (args: any) => Promise<IApiResponse>;
  getTripInfo: (args: any) => Promise<IApiResponse>;
  manageTripInfo: (args: any) => Promise<IApiResponse>;
  getBrokerCommission: (args: any) => Promise<IApiResponse>;
  manageBrokerCommission: (args: any) => Promise<IApiResponse>;
  getIndents: (args: any) => Promise<IApiResponse>;
  getIndentInfo: (args: any) => Promise<IApiResponse>;
  getTripStatus: (args: any) => Promise<IApiResponse>;
  manageTripStatus: (args: any) => Promise<IApiResponse>;
  getIndentCharges: (args: any) => Promise<IApiResponse>;
  manageIndentCharges: (args: any) => Promise<IApiResponse>;
  getIndentPayments: (args: any) => Promise<IApiResponse>;
  manageIndentPayments: (args: any) => Promise<IApiResponse>;
  getPaymentDetails: (args: any) => Promise<IApiResponse>;
  managePaymentDetails: (args: any) => Promise<IApiResponse>;
  manageLoadingPoint: (args: any) => Promise<IApiResponse>;
  getLoadingPoints: (args: any) => Promise<IApiResponse>;
  manageIndentInvoice: (args: any) => Promise<IApiResponse>;
  getIndentInvoices: (args: any) => Promise<IApiResponse>;
  getLoadUnloadPoints: (args: any) => Promise<IApiResponse>;
  getOdometerInfo: (args: any) => Promise<IApiResponse>;
  manageIndentContactReport: (args: any) => Promise<IApiResponse>;
  getIndentContactReports: (args: any) => Promise<IApiResponse>;
  manageVehicleInspection: (args: any) => Promise<IApiResponse>;
  getVehicleInspections: (args: any) => Promise<IApiResponse>;
  manageIndentPlacement: (args: any) => Promise<IApiResponse>;
  manageIndentBillDetails: (args: any) => Promise<IApiResponse>;
  getTripPrint: (args: any) => Promise<IApiResponse>;
  getReturnPickups: (args: any) => Promise<IApiResponse>;
  manageReturnPickup: (args: any) => Promise<IApiResponse>;
  getVehicleOnMap: (args: any) => Promise<IApiResponse>;
}

const local = PRODUCTION === "false" && UAT === "false";

export class ApiIndents implements IApiIndents {
  removePodAttachment = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/HSO4PQLE8C9FWBZM";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageLoadingPtComment = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/W1K9HLEBO4JDCR3T";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getLoadingPtComments = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/S8WT2FVI79YE1GLC";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
  // todo : Api not done getVehicleTrack
  getVehicleTrack = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/CKWHE93BFNUODA87";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = {
        status: 200,
        response: {
          records: [
            {
              route_details: {
                route_length: 4,
                top_speed: 48,
                avg_speed: 0,
                move_duration: 577,
                stop_duration: 0,
              },
              route_points: [
                {
                  latitude: 10.9764633,
                  longitude: 77.2226383,
                },
                {
                  latitude: 10.9864633,
                  longitude: 77.2326383,
                },
                {
                  latitude: 11.9764633,
                  longitude: 77.2326383,
                },
                {
                  latitude: 14.9764633,
                  longitude: 77.2326383,
                },
                {
                  latitude: 11.9764633,
                  longitude: 77.4326383,
                },
                {
                  latitude: 12.9764633,
                  longitude: 77.8326383,
                },
                {
                  latitude: 13.1764633,
                  longitude: 77.2326383,
                },
              ],
              route_parkings: [
                {
                  lat: 10.9767016,
                  lng: 77.2327316,
                  cameAt: "2023-10-03 14:00:09",
                  leftAt: "2023-10-03 14:41:43",
                },
                {
                  lat: 10.9764516,
                  lng: 78.2328633,
                  cameAt: "2023-10-03 14:42:16",
                  leftAt: "2023-10-03 15:03:17",
                },
              ],
            },
          ],
        },
      };
      return resObj;
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getVehicleOnMap = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/CKWHE93BFNUODA87";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getVehicleOnRadar = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/67TAPU4X9WZG1E23";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getReturnPickups = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/78CENK6IWHTL10F3",
        API_CONFIG.METHODS.GET,
        args,
        true
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageReturnPickup = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/UNV9P3K8TZIYF5X7",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  //
  getTripPrint = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/96USVZLXORE5AP7G",
        API_CONFIG.METHODS.POST,
        args,
        true
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageIndentBillDetails = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/OZ6QKP7D3EJAU5WH",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageIndentPlacement = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/0FDTXI62PG51Z7RA";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getVehicleInspections = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/JO4VM9C3T8PHIW76",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageVehicleInspection = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/AJ92S5Z7Q1E8VBFN",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getIndentContactReports = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/DFOUZBGYV63X08EI",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageIndentContactReport = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/K3G2B9YONZ18ETLJ",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getOdometerInfo = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/5K26XU7ITMPELB9W",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  sendPushNotify = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/897G4270H81360FI",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getReportedVehicles = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/2EZRBGI4APHK375T",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageReportedVehicles = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/C0BOTRAJGP4FUQWV",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getVehicleInfo = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/9LY62CDQORAHGBN4",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  removeReportedVehicle = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/KDS9OR3B4AHZX872",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageIndent = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/5JTA02UDEFC9OQZP";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  linkIndent = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/9G4CVIPEZ1HQ7XW8",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getLoadUnloadPoints = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/0SQK18U73ZB5LY4J";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getIndentsDropdown = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/6RNL3QVDICF9X4GW",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTrips = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/C2IY8MT5FLJEDBPS";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTripsList = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/GO3HTSKFBC6J4ZVR";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getLinkedTrips = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/AYHUM8GSJ9L2DZB0",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTripInfo = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/RLNTJ8P1E37V95ZM",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageTripInfo = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/57FN9G3DL1T4WUMS",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getBrokerCommission = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/0MNH9S6P2QVT7C1L",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageBrokerCommission = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/76U8VAZYT2ORJD5S",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getIndents = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/JYVWUEKBXZS851NQ",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getIndentInfo = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/UAD48BWTEF0YCVOI",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getTripStatus = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/7CE8KJOYVIDZ36Q4",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageTripStatus = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/SYQAX9KTE2CDRHL0",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getIndentCharges = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/4WQZSUBKL9N67HA3",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageIndentCharges = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/A8LX1R4E2C7M0QGH",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getIndentPayments = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/E6VBTNC1480FQ3YM";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageIndentPayments = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/L5MKZBUSGWFHJ7V4";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getPaymentDetails = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/850DQ6TZVHFJKRPC",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  managePaymentDetails = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/H76QNKCY4U9MVDWG",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getLoadingPoints = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/ZSROBTMKP4IYU6Q5",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageLoadingPoint = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/W38RJKXIYFMPH4ZT",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getIndentInvoices = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/PL7Z2FMY4NR6EKSV",
        API_CONFIG.METHODS.GET,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageIndentInvoice = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      resObj = await COMMON_JS.callApi(
        "/in/v1/OZ2J8LIW9QMU0TYN",
        API_CONFIG.METHODS.POST,
        args
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  manageIndentLedgerFiles = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/GDK8LIM35J6CPAZ9";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getIndentLedgerFileInfo = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/LV98O6ZEDH1KPRTA";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  fileUpload = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/0FBOU4MX76WPA2ST";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.POST,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };

  getFile = async (args: any): Promise<IApiResponse> => {
    let resObj: any = {
      status: 500,
      response: {},
      error: "",
    };
    try {
      let apiUrl = "/in/v1/RQ6S1WH9GVXFPCB4";
      if (local) {
        apiUrl = LOCAL_URL + ":8004" + apiUrl;
      }
      resObj = await COMMON_JS.callApi(
        apiUrl,
        API_CONFIG.METHODS.GET,
        args,
        false,
        local
      );
    } catch (err: any) {
      resObj.error = err.toString();
    }
    return resObj;
  };
}
